<template>
    <div class="container-fluid no-fluid">
        <div class="row sm-gutters">
            <div class="col-sm-12 col-md-12">
                <ul class="nav nav-tabs nav-pills settings-nav">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" :class="{ 'active': 'Dashboard' === $route.name }"
                            @click="openDashboard">
                            {{ t("tradingMenuItem") }}
                        </button>
                    </li>
                    <!--<li class="nav-item" role="presentation">
                        <button class="nav-link" :class="{ 'active': 'Trader' === $route.name }" @click="openTrader">
                            {{ t("tradingMenuItem") }}
                        </button>
                    </li>-->
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" :class="{ 'active': 'Wallet' === $route.name }" @click="openWallet">
                            {{ t("walletMenuItem") }}
                        </button>
                    </li>
                </ul>                
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title text-center balance-summary-title">{{ t("balanceSummaryLabel") }}</h5>
                        <div class="d-flex justify-content-center">
                            <div class="form-inline my-auto balance-summary-content">
                                <!-- graph -->
                                <div class="d-flex align-items-center justify-content-center balance-summary-chart">
                                    <PieChart :height="120" :data="[parseFloat(totalEquitiesValue), parseFloat(getFreeFunds)]" :labels="[t('positionsLabel'), t('freeFundsLabel')]" :tooltip-value-formatter="formatChartValue"></PieChart>
                                </div>
                                <!-- total assets -->
                                <div class="d-flex align-items-center justify-content-center balance-summary-total">
                                    <h4><b>{{ formatPrice(totalBalance, getCurrency, 2).replace(" ", "&nbsp;") }}</b></h4>
                                </div>
                                <!-- free funds -->
                                <div class="form-group pt-0">
                                    <span class="dot_money" />&nbsp;<span class="balance-menu-label">{{ t("freeFundsLabel") }}</span><br />
                                    <strong class="balance-menu-value">{{ formatPrice(getFreeFunds, getCurrency, 2).replace(" ", "&nbsp;") }}&nbsp;<small class="balance-menu-percentage">({{
                                        formatNumber(getFreeFundsPercentage) }}%)</small></strong>
                                </div>
                                <!-- total equities -->
                                <div class="form-group pt-0">
                                    <span class="dot_instruments" />&nbsp;<span class="balance-menu-label">{{ t("positionsLabel") }}</span><br />
                                    <strong class="balance-menu-value">{{ formatPrice(totalEquitiesValue, getCurrency, 2).replace(" ", "&nbsp;") }}&nbsp;<small class="balance-menu-percentage">({{
                                        formatNumber(getEquitiesPercentage) }}%)</small></strong>
                                </div>
                                <!-- available to invest -->
                                <div class="form-group pt-0">
                                    <span class="balance-menu-label">{{ t("excessFundsLabel") }}</span><br />
                                    <strong class="balance-menu-value">{{ formatPrice(getExcessFunds, getCurrency, 2).replace(" ", "&nbsp;") }}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--<div class="card mtb15">
                    <div class="card-header">
                        <button class="btn btn-primary w-100" type="button" data-bs-toggle="collapse" data-bs-target="#myPostionsCollapse" aria-expanded="false" aria-controls="myPostionsCollapse">
                            {{ t("myPositionsLabel") }} {{ getTotalPositionsCount }}
                        </button>
                    </div>
                    <div class="collapse" id="myPostionsCollapse">
                        <div class="card card-body">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>{{ t("assetLabel") }}</th>
                                            <th>{{ t("countLabel") }}</th>
                                            <th>&Sigma;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="0 < getTotalEquitiesCount">
                                            <td>{{ t("equitiesLabel") }}</td>
                                            <td>{{ getTotalEquitiesCount }}</td>
                                            <td>{{ formatNumber(getTotalEquitiesValue) }}</td>
                                        </tr>
                                        <tr v-if="0 < getTotalBondsCount">
                                            <td>{{ t("bondsLabel") }}</td>
                                            <td>{{ getTotalBondsCount }}</td>
                                            <td>{{ formatNumber(getTotalBondsValue) }}</td>
                                        </tr>
                                        <tr v-if="0 < getTotalCompInstrumentsCount">
                                            <td>{{ t("compInstrumentsLabel") }}</td>
                                            <td>{{ getTotalCompInstrumentsCount }}</td>
                                            <td>{{ formatNumber(getTotalCompInstrumentsValue) }}</td>
                                        </tr>
                                        <tr v-if="0 < getTotalFundsCount">
                                            <td>{{ t("fundsLabel") }}</td>
                                            <td>{{ getTotalFundsCount }}</td>
                                            <td>{{ formatNumber(getTotalFundsValue) }}</td>
                                        </tr>
                                        <tr v-if="0 < getTotalReitsCount">
                                            <td>{{ t("reitsLabel") }}</td>
                                            <td>{{ getTotalReitsCount }}</td>
                                            <td>{{ formatNumber(getTotalReitsValue) }}</td>
                                        </tr>
                                        <tr v-if="0 < getTotalRightsCount">
                                            <td>{{ t("rightsLabel") }}</td>
                                            <td>{{ getTotalRightsCount }}</td>
                                            <td>{{ formatNumber(getTotalRightsValue) }}</td>
                                        </tr>
                                        <tr v-if="0 < getTotalCfdCount">
                                            <td>{{ t("cfdLabel") }}</td>
                                            <td>{{ getTotalCfdCount }}</td>
                                            <td>{{ formatNumber(getTotalCfdValue) }}</td>
                                        </tr>
                                        <tr v-if="0 < getTotalMarginCount">
                                            <td>{{ t("marginLabel") }}</td>
                                            <td>{{ getTotalMarginCount }}</td>
                                            <td>{{ formatNumber(getTotalMarginValue) }}</td>
                                        </tr>
                                        <tr v-if="0 < getTotalNettingCount">
                                            <td>{{ t("nettingLabel") }}</td>
                                            <td>{{ getTotalNettingCount }}</td>
                                            <td>{{ formatNumber(getTotalNettingValue) }}</td>
                                        </tr>
                                        <tr v-if="0 < getTotalRepoCount">
                                            <td>{{ t("repoLabel") }}</td>
                                            <td>{{ getTotalRepoCount }}</td>
                                            <td>{{ formatNumber(getTotalRepoValue) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
import UiUtils from "@/assets/js/ui_utils.js";
import I18n from "@/lang/i18n.js";
import PieChart from "@/components/charts/PieChart.vue";
import { getPortfolioSummary } from "@/features/wallet/wallet-portfolio-metrics";
import minusIcon from "@/assets/images/Circle-plus-1.svg";
import plusIcon from "@/assets/images/Circle-plus.svg";

export default {
    components: {
        PieChart
    },
    data() {
        return {
            minusIcon,
            plusIcon
        };
    },
    methods: {
        openWallet() {
            this.$router.push({ name: "Wallet" });
        },
        openDashboard() {
            this.$router.push({ name: "Dashboard" });
        },
        openProfile() {
            this.$router.push({ name: "Profile" });
        },
        openTrader() {
            this.$router.push({ name: "Trader" });
        },
        getUserLanguage() {
            return this.$store.getters["getNonLoggedInLanguage"]?.toUpperCase() || "EN";
        },
        formatNumber(val) {
            return UiUtils.formatNumber(val);
        },
        formatPrice(val, curr, autoDigits = null) {
            return UiUtils.formatPrice(val, curr, this.getUserLanguage(), autoDigits);
        },
        formatChartValue(value) {
            return this.formatPrice(value, this.getCurrency, 2);
        },
        t(key, ...args) {
            return I18n.t(key, this.getUserLanguage(), ...args);
        }
    },
    computed: {    
        getUserType() {
            return this.$store.getters["getUserType"];
        },           
        getCurrency() {
            return this.$store.getters["getCurrency"].toUpperCase();
        }, 
        portfolioSummary() {
            const userWallet = this.$store.getters["getWallet"];
            const stocks = this.$store.getters["getStocks"];
            const indexedStocks = this.$store.getters["getIndexedStocks"];
            const quotes = this.$store.getters["getQuotes"];

            return getPortfolioSummary({
                wallet: userWallet,
                stocks,
                indexedStocks,
                quotes,
                currency: this.getCurrency
            });
        },
        totalAssetsValue() {
            return this.portfolioSummary.totalAssetsValue;
        },
        totalEquitiesValue() {
            return this.portfolioSummary.totalEquitiesValue;
        },
        totalBalance() {
            return this.portfolioSummary.totalBalance;
        },
        getMoneyPercentage() {
            return this.portfolioSummary.moneyPercentage;
        },
        getEquitiesPercentage() {
            return this.portfolioSummary.equitiesPercentage;
        },
        getTotalPositionsCount() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let allAssetsCount = 0;
            userWallet.s.forEach(element => {
                allAssetsCount += element.am;
            });
            return allAssetsCount;
        },
        getTotalEquitiesCount() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                if (1 === element.stid) {
                    assetsCount += element.am;
                }
            });
            return assetsCount;
        },
        getTotalEquitiesValue() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                const mp = element.ldp
                    ? element.ldp
                    : element.mp;
                if (1 === element.stid) {
                    assetsCount += mp;
                }
            });
            return assetsCount;
        },
        getTotalBondsCount() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                if (2 === element.stid) {
                    assetsCount += element.am;
                }
            });
            return assetsCount;
        },
        getTotalBondsValue() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                const mp = element.ldp
                    ? element.ldp
                    : element.mp;
                if (2 === element.stid) {
                    assetsCount += mp;
                }
            });
            return assetsCount;
        },
        getTotalCompInstrumentsCount() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                if (3 === element.stid) {
                    assetsCount += element.am;
                }
            });
            return assetsCount;
        },
        getTotalCompInstrumentsValue() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                const mp = element.ldp
                    ? element.ldp
                    : element.mp;
                if (3 === element.stid) {
                    assetsCount += mp;
                }
            });
            return assetsCount;
        },
        getTotalFundsCount() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                if (4 === element.stid) {
                    assetsCount += element.am;
                }
            });
            return assetsCount;
        },
        getTotalFundsValue() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                const mp = element.ldp
                    ? element.ldp
                    : element.mp;
                
                if (4 === element.stid) {
                    assetsCount += mp;
                }
            });
            return assetsCount;
        },
        getTotalReitsCount() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                if (5 === element.stid) {
                    assetsCount += element.am;
                }
            });
            return assetsCount;
        },
        getTotalReitsValue() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                const mp = element.ldp
                    ? element.ldp
                    : element.mp;
                if (5 === element.stid) {
                    assetsCount += mp;
                }
            });
            return assetsCount;
        },
        getTotalRightsCount() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                if (6 === element.stid) {
                    assetsCount += element.am;
                }
            });
            return assetsCount;
        },
        getTotalRightsValue() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                const mp = element.ldp
                    ? element.ldp
                    : element.mp;
                if (6 === element.stid) {
                    assetsCount += mp;
                }
            });
            return assetsCount;
        },
        getTotalCfdCount() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                if (7 === element.stid) {
                    assetsCount += element.am;
                }
            });
            return assetsCount;
        },
        getTotalCfdValue() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                const mp = element.ldp
                    ? element.ldp
                    : element.mp;
                if (7 === element.stid) {
                    assetsCount += mp;
                }
            });
            return assetsCount;
        },
        getTotalMarginCount() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                if (8 === element.stid) {
                    assetsCount += element.am;
                }
            });
            return assetsCount;
        },
        getTotalMarginValue() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                const mp = element.ldp
                    ? element.ldp
                    : element.mp;
                if (8 === element.stid) {
                    assetsCount += mp;
                }
            });
            return assetsCount;
        },
        getTotalNettingCount() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                if (9 === element.stid) {
                    assetsCount += element.am;
                }
            });
            return assetsCount;
        },
        getTotalNettingValue() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                const mp = element.ldp
                    ? element.ldp
                    : element.mp;
                if (9 === element.stid) {
                    assetsCount += mp;
                }
            });
            return assetsCount;
        },
        getTotalRepoCount() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                if (10 === element.stid) {
                    assetsCount += element.am;
                }
            });
            return assetsCount;
        },
        getTotalRepoValue() {
            const userWallet = this.$store.getters["getWallet"];
            if (!userWallet) {
                return 0;
            }
            let assetsCount = 0;
            userWallet.s.forEach(element => {
                const mp = element.ldp
                    ? element.ldp
                    : element.mp;                
                if (10 === element.stid) {
                    assetsCount += mp;
                }
            });
            return assetsCount;
        },
        totalBuySettlementAmount() {
            return this.portfolioSummary.totalBuySettlementAmount;
        },
        totalSellSettlementAmount() {
            return this.portfolioSummary.totalSellSettlementAmount;
        },
        getFreeFunds() {
            return this.portfolioSummary.freeFunds;
        },
        getFreeFundsPercentage() {
            if (0 === this.totalBalance) {
                return 0;
            }

            const percent = this.getFreeFunds / this.totalBalance * 100;
            return Math.min(Math.max(percent, 0), 100);
        },
        getGuaranteeDeposit() {
            return this.portfolioSummary.guaranteeDeposit;
        },
        getExcessFunds() {
            return this.portfolioSummary.excessFunds;
        },
        getAvailableToWithdraw() {
            return this.portfolioSummary.availableToWithdraw;
        }
    },   
}
</script>

<style scoped>
.balance-menu-value,
.balance-menu-value small {
  font-size: 1rem;
  line-height: 1.35;
}
.balance-menu-label {
  font-size: 1rem;
  line-height: 1.35;
}
.balance-summary-content {
  min-width: 0;
  width: 100%;
}
.balance-summary-content .form-group {
  min-width: 0;
  width: 100%;
}
.balance-summary-content .balance-menu-value {
  overflow-wrap: anywhere;
}
.balance-menu-percentage {
  display: inline;
}
@media (max-width: 1449px) {
  .balance-menu-percentage {
    display: block;
  }
}
.balance-summary-title {
  margin-bottom: 6px;
}
.balance-summary-chart {
  margin-bottom: 6px;
}
.balance-summary-total h4 {
  margin-bottom: 0;
}
.balance-summary-total + .form-group {
  margin-top: 2rem;
}
.dot_money {
    height: 10px;
    width: 10px;
    background-color: #189e18;
    border-radius: 50%;
    display: inline-block;
}
.dot_instruments {
    height: 10px;
    width: 10px;
    background-color: #0088AA;
    border-radius: 50%;
    display: inline-block;
}
.label-with-sign-icon {
    align-items: center;
    display: inline-flex;
    gap: 0.15rem;
    line-height: inherit;
}
.sign-icon {
    display: block;
    flex: 0 0 14px;
    height: 14px;
    width: 14px;
}
</style>
